/**
 * @generated SignedSource<<c1dec488389b62891aa3cb2fc6bb7447>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectViewMoreContainer_searchResult$data = {
  readonly firm: {
    readonly name: string | null;
    readonly publicProfile: {
      readonly designProjectsCover: ReadonlyArray<{
        readonly addressDisplayString: string | null;
        readonly coverPhoto: string | null;
        readonly name: string | null;
        readonly serviceId: string | null;
        readonly url: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly project: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "ProjectViewMoreContainer_searchResult";
};
export type ProjectViewMoreContainer_searchResult$key = {
  readonly " $data"?: ProjectViewMoreContainer_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectViewMoreContainer_searchResult">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectViewMoreContainer_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "designProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmPublicProfileType",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DesignProjectCover",
              "kind": "LinkedField",
              "name": "designProjectsCover",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "addressDisplayString",
                  "storageKey": null
                },
                (v0/*:: as any*/),
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "coverPhoto",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeInteriorProjectQueryOutput",
  "abstractKey": null
};
})();

(node as any).hash = "644220fcd65180686390e358afb1a96f";

export default node;
